import { render, staticRenderFns } from "./DictionaryIcon.vue?vue&type=template&id=78cd4dbd&scoped=true&"
import script from "./DictionaryIcon.vue?vue&type=script&lang=js&"
export * from "./DictionaryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cd4dbd",
  null
  
)

export default component.exports